/**
 * SLO Space – Hash-triggered popups (contact, newsletter, …)
 * Opens via URL hash per [data-contact-hash]; overlay, close button, ESC
 */

(function() {
  'use strict';

  if (typeof window.ContactPopup === 'undefined') {
    window.ContactPopup = {
      initialized: false,

      init: function() {
        if (this.initialized) return;
        this.initialized = true;

        var popups = document.querySelectorAll('.contact-popup[data-contact-hash]');
        if (!popups.length) return;

        function checkHashAll() {
          popups.forEach(function(popup) {
            var hashValue = (popup.getAttribute('data-contact-hash') || '').replace(/^#/, '');
            var targetHash = '#' + hashValue;
            if (window.location.hash === targetHash) {
              ContactPopup.open(popup);
            } else {
              ContactPopup.close(popup);
            }
          });
        }

        window.addEventListener('hashchange', checkHashAll);
        checkHashAll();

        function openPopupsWithFormFeedback() {
          var anyOpened = false;
          popups.forEach(function(popup) {
            var formEl = popup.querySelector('.contact-popup__form');
            if (!formEl) return;
            var success = formEl.querySelector('.contact-popup__success');
            var errors = formEl.querySelector('.contact-popup__errors');
            var hasErrors = errors && errors.textContent.replace(/\s+/g, ' ').trim().length > 0;
            if (success || hasErrors) {
              ContactPopup.open(popup);
              anyOpened = true;
            }
          });
          if (anyOpened) {
            var params = new URLSearchParams(window.location.search);
            if (params.has('contact_posted') || params.has('customer_posted')) {
              params.delete('contact_posted');
              params.delete('customer_posted');
              var qs = params.toString();
              history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
            }
          }
        }

        openPopupsWithFormFeedback();

        document.addEventListener('click', function(e) {
          var closeEl = e.target.closest('[data-contact-popup-close]');
          if (closeEl) {
            var p = closeEl.closest('.contact-popup');
            if (p && (closeEl.classList.contains('contact-popup__overlay') || closeEl.classList.contains('contact-popup__close'))) {
              ContactPopup.close(p);
            }
          }
        });

        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') {
            var openPopup = document.querySelector('.contact-popup.is-open');
            if (openPopup) {
              ContactPopup.close(openPopup);
            }
          }
        });

        function replaceFormWithSuccess(form, messageText) {
          var wrap = document.createElement('div');
          wrap.className = 'contact-popup__success text-body';
          wrap.setAttribute('role', 'status');
          wrap.setAttribute('tabindex', '-1');
          wrap.textContent = messageText;
          form.parentNode.insertBefore(wrap, form);
          form.remove();
          wrap.focus();
        }

        function clearServerErrors(form) {
          var existing = form.querySelectorAll('.contact-popup__server-errors');
          existing.forEach(function(n) {
            n.remove();
          });
        }

        function showServerFormErrorsHtml(form, html) {
          clearServerErrors(form);
          var div = document.createElement('div');
          div.className = 'contact-popup__errors text-small contact-popup__server-errors';
          div.setAttribute('role', 'alert');
          div.innerHTML = html;
          form.insertBefore(div, form.firstChild);
        }

        function showGenericFormError(form, text) {
          clearServerErrors(form);
          var div = document.createElement('div');
          div.className = 'contact-popup__errors text-small contact-popup__server-errors';
          div.setAttribute('role', 'alert');
          div.textContent = text;
          form.insertBefore(div, form.firstChild);
        }

        function submitPopupFormAjax(form, popup) {
          var successMsg = popup.getAttribute('data-popup-form-success') || '';
          var errorGeneric = popup.getAttribute('data-popup-form-error-generic') || '';
          var challengeMsg = popup.getAttribute('data-popup-captcha-challenge') || errorGeneric;
          var submitBtn = form.querySelector('.contact-popup__submit');
          var action = (form.getAttribute('action') || '/contact').split('#')[0];

          if (submitBtn) {
            submitBtn.disabled = true;
          }

          preparePopupFormForServer(form);

          var fd = new FormData(form);

          return fetch(action, {
            method: 'POST',
            body: fd,
            credentials: 'same-origin',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
            .then(function(res) {
              return res.text().then(function(html) {
                return { res: res, html: html };
              });
            })
            .then(function(ctx) {
              var url = ctx.res.url || '';
              if (url.indexOf('/challenge') !== -1) {
                showGenericFormError(form, challengeMsg);
                return;
              }
              if (url.indexOf('contact_posted=true') !== -1 || url.indexOf('customer_posted=true') !== -1) {
                replaceFormWithSuccess(form, successMsg);
                return;
              }

              var doc = new DOMParser().parseFromString(ctx.html, 'text/html');
              var formTypeInput = form.querySelector('[name="form_type"]');
              var formType = formTypeInput ? formTypeInput.value : '';

              var popupId = popup.id;
              var remotePopup = popupId ? doc.getElementById(popupId) : null;
              if (remotePopup) {
                var remoteForm = remotePopup.querySelector('.contact-popup__form');
                var remoteSuccess = remoteForm
                  ? remoteForm.querySelector('.contact-popup__success')
                  : remotePopup.querySelector('.contact-popup__success');
                var remoteErrors = remoteForm
                  ? remoteForm.querySelector('.contact-popup__errors')
                  : remotePopup.querySelector('.contact-popup__errors');
                if (remoteSuccess && remoteSuccess.textContent.replace(/\s+/g, ' ').trim()) {
                  replaceFormWithSuccess(form, successMsg);
                  return;
                }
                if (remoteErrors && remoteErrors.textContent.replace(/\s+/g, ' ').trim()) {
                  showServerFormErrorsHtml(form, remoteErrors.innerHTML);
                  return;
                }
              }

              var responseForm = null;
              if (form.id) {
                responseForm = doc.getElementById(form.id);
              }
              if (!responseForm) {
                var candidates = doc.querySelectorAll('form#contact_form');
                for (var ri = 0; ri < candidates.length; ri++) {
                  var t = candidates[ri].querySelector('[name="form_type"]');
                  if (t && formType && t.value === formType) {
                    responseForm = candidates[ri];
                    break;
                  }
                }
                if (!responseForm && candidates.length) {
                  responseForm = candidates[0];
                }
              }

              if (responseForm) {
                var ge = responseForm.querySelector('.errors');
                if (ge && ge.textContent.replace(/\s+/g, ' ').trim()) {
                  showServerFormErrorsHtml(form, ge.innerHTML);
                  return;
                }
                if (ctx.res.ok) {
                  replaceFormWithSuccess(form, successMsg);
                  return;
                }
              }

              showGenericFormError(form, errorGeneric);
            })
            .catch(function() {
              showGenericFormError(form, errorGeneric);
            })
            .finally(function() {
              if (submitBtn) {
                submitBtn.disabled = false;
              }
            });
        }

        function preparePopupFormForServer(form) {
          var pageUrlInput = form.querySelector('[data-contact-page-url]');
          if (pageUrlInput) {
            pageUrlInput.value = window.location.origin + window.location.pathname + (window.location.search || '');
          }
          var bodyField = form.querySelector('[name="contact[body]"]');
          if (!bodyField) return;

          var extraLines = [];
          var companyInput = form.querySelector('[data-contact-company]');
          if (companyInput && companyInput.value.trim()) {
            extraLines.push('Company: ' + companyInput.value.trim());
          }
          var goalSelect = form.querySelector('[name="contact[goal]"]');
          if (goalSelect && goalSelect.value.trim()) {
            extraLines.push('Goal: ' + goalSelect.value.trim());
          }
          var planSelect = form.querySelector('[name="contact[plan]"]');
          if (planSelect && planSelect.value.trim()) {
            extraLines.push('Plan: ' + planSelect.value.trim());
          }
          if (!extraLines.length) return;

          var missingLines = extraLines.filter(function(line) {
            return bodyField.value.indexOf(line) === -1;
          });
          if (!missingLines.length) return;

          var prefix = missingLines.join('\n');
          var message = bodyField.value.trim();
          bodyField.value = message ? prefix + '\n\n' + message : prefix;
        }

        popups.forEach(function(popup) {
          var form = popup.querySelector('.contact-popup__form');
          if (!form) return;

          form.setAttribute('novalidate', '');

          var validationFields = form.querySelectorAll('.contact-popup__field[data-validation-field]');
          validationFields.forEach(function(fieldEl) {
            var input = fieldEl.querySelector('input, textarea, select');
            if (input) {
              input.addEventListener('input', clearInvalid);
              input.addEventListener('change', clearInvalid);
            }
          });

          function runUserInitiatedSend() {
            if (!validateForm(form)) return;
            if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
              window.Shopify.captcha.protect(form, function() {
                form.submit();
              });
            } else {
              form.submit();
            }
          }

          form.addEventListener(
            'submit',
            function(ev) {
              ev.preventDefault();
              ev.stopPropagation();
              runUserInitiatedSend();
            },
            true
          );

          var sendBtn = form.querySelector('[data-contact-popup-send]');
          if (sendBtn) {
            sendBtn.addEventListener('click', function() {
              runUserInitiatedSend();
            });
          }
        });

        function clearInvalid() {
          var field = this.closest('.contact-popup__field');
          if (field) field.classList.remove('is-invalid');
        }

        function validateForm(form) {
          var fields = form.querySelectorAll('.contact-popup__field[data-validation-field]');
          var allValid = true;
          fields.forEach(function(fieldEl) {
            var message = fieldEl.getAttribute('data-validation-message');
            var input = fieldEl.querySelector('input, textarea, select');
            if (!input) return;
            fieldEl.classList.remove('is-invalid');
            fieldEl.removeAttribute('data-tooltip');
            var valid = true;
            if (input.type === 'checkbox') {
              valid = input.checked;
            } else if (input.type === 'email') {
              var val = input.value.trim();
              valid = val.length > 0 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
              if (val.length > 0 && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
                message = fieldEl.getAttribute('data-validation-email-message') || 'Please enter a valid email';
              }
            } else {
              valid = input.value.trim().length > 0;
            }
            if (!valid) {
              allValid = false;
              fieldEl.setAttribute('data-tooltip', message);
              fieldEl.classList.add('is-invalid');
            }
          });
          return allValid;
        }

        if (!window.__sloContactPopupFormSubmitPatched) {
          window.__sloContactPopupFormSubmitPatched = true;
          var nativeFormSubmit = HTMLFormElement.prototype.submit;
          HTMLFormElement.prototype.submit = function() {
            if (!this.classList || !this.classList.contains('contact-popup__form')) {
              return nativeFormSubmit.call(this);
            }
            var popupRoot = this.closest('.contact-popup');
            if (!popupRoot || !popupRoot.hasAttribute('data-contact-hash')) {
              return nativeFormSubmit.call(this);
            }
            if (!validateForm(this)) return;
            submitPopupFormAjax(this, popupRoot);
          };
        }
      },

      open: function(popup) {
        if (!popup) return;

        document.querySelectorAll('.contact-popup.is-open').forEach(function(p) {
          if (p !== popup) {
            ContactPopup.close(p);
          }
        });

        var otherProduct = document.querySelector('.product-popup.is-open');
        if (otherProduct && typeof window.ProductPopup !== 'undefined') {
          window.ProductPopup.close(otherProduct);
        }

        popup.removeAttribute('hidden');
        popup.classList.add('is-open');
        document.body.style.overflow = 'hidden';

        var firstField = popup.querySelector(
          '.contact-popup__form input:not([type="hidden"]):not([disabled]), .contact-popup__form textarea:not([disabled]), .contact-popup__form select:not([disabled])'
        );
        if (firstField) {
          firstField.focus({ preventScroll: true });
        } else {
          var container = popup.querySelector('.contact-popup__container');
          if (container) {
            container.setAttribute('tabindex', '-1');
            container.focus({ preventScroll: true });
          }
        }
      },

      close: function(popup) {
        if (!popup) return;

        popup.classList.remove('is-open');

        var hasOtherPopup = document.querySelector('.product-popup.is-open');
        var hasOtherHashPopup = document.querySelector('.contact-popup.is-open');
        if (!hasOtherPopup && !hasOtherHashPopup) {
          document.body.style.overflow = '';
        }

        var hash = (popup.getAttribute('data-contact-hash') || 'contact').replace(/^#/, '');
        if (window.location.hash === '#' + hash) {
          history.replaceState(null, '', window.location.pathname + window.location.search);
        }

        setTimeout(function() {
          if (!popup.classList.contains('is-open')) {
            popup.setAttribute('hidden', '');
          }
        }, 200);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        ContactPopup.init();
      });
    } else {
      ContactPopup.init();
    }
  }
})();
